import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Link, Navigate, useNavigate, useSearchParams } from 'react-router-dom'
import SampleBg from '../images/candidate-login/sample.svg'
import {
  fetchPlacementDrivesData,
  createJobApplication,
  handelOpenToWork
} from '../../features/constants/apis'
import { toast } from 'react-toastify'
import { Splide, SplideSlide } from '@splidejs/react-splide'
import Quotes from '../images/testDetails/quote.png'
import ReviewUser from '../images/testDetails/user1.jpg'
import Accordion from 'react-bootstrap/Accordion'
import axios from '../../AxiosConfig'
import { paymentGatewayVerifyPlacementDrive } from '../../features/constants/apis'
import { Modal, Button } from 'react-bootstrap'

const DriveDetail = ({ ID, authToken, role }) => {
  console.log(ID)
  // console.log("ID form store: ", ID, authToken, role);

  let navigate = useNavigate()
  const [PDriveData, setPDriveData] = useState()
  const [disableButton, setDisableButton] = useState(false)
  const [btnLoder, setLoder] = useState(false)
  const [refreshData, setRefreshData] = useState(false)
  const [showSuccessMessageModal, setShowSuccessMessageModal] = useState({ action: false, type: '' })
  const [searchParams] = useSearchParams()
  const DriveID = searchParams.get('ID')
  console.log('placemnet drive ID:', DriveID)

  useEffect(() => {
    if (DriveID) {
      localStorage.removeItem('landingUrl')
      localStorage.removeItem('pdID')
      localStorage.removeItem('driveDetail')
    }
  }, [DriveID])

  useEffect(() => {
    const getPlacemnetDriveById = async () => {
      const response = await fetchPlacementDrivesData(DriveID, authToken)
      console.log('response: ', response.data)
      console.log('status: ', response.data?.status)
      setPDriveData(response.data)
      if (response?.data?.status === 'Applied') {
        setDisableButton(true)
        console.log(' placemnet drive is applied already!')
      }
    }
    getPlacemnetDriveById()
  }, [refreshData])
  // console.log("pDriveData: ", PDriveData);

  const handelEdit = () => {
    navigate(`/new-placement-drive-form?ID=${DriveID}`)
  }

  const handleApply = applicationStatus => {
    if (applicationStatus == 'Applied') {
      setDisableButton(true)
      const data = {
        UserId: ID,
        Amount: '1000',
        CouponCode: '',
        PaymentSource: 'Placement Drive',
        AppliedTo: 'Placement Drive',
        PlacementDriveId: DriveID
      }
      axios.post('/placementdrive/create-order', data).then(res => {
        if (res.data.message === 'Success') {
          handlePayment(res.data.orderId)
        } else {
          console.log('FAILED')
        }
      })
    } else {
      console.log('handel applay working')
      setDisableButton('applying')
      const data = {
        EmpID: PDriveData.EmployerID,
        JobID: null,
        JobTitle: null,
        placementID: PDriveData.ID,
        tokenUserID: ID,
        status: applicationStatus
      }

      const drive = async () => {
        const driveData = await createJobApplication(data, authToken)
        if (driveData?.data === 'Job appliation created successfully!') {
          // toast.success('Apllied successfully!', {
          //   position: 'top-right',
          //   autoClose: 5000,
          //   hideProgressBar: false,
          //   closeOnClick: true,
          //   pauseOnHover: true,
          //   draggable: true,
          //   progress: undefined,
          //   theme: 'light'
          // })
          setShowSuccessMessageModal({ action: true, type: 'apply' })
          setTimeout(() => {
            setShowSuccessMessageModal({ action: false, type: '' })
          }, 3000);
          setRefreshData(prev => !prev)
        }
      }
      drive()
    }
  }

  const handlePayment = async orderId => {
    console.log(orderId)
    setDisableButton(true)
    const res = await loadRazorpayScript()

    if (!res) {
      alert('Razorpay SDK failed to load. Are you online?')
      return
    }

    // Create a new order from the backend
    //   const response = await paymentGateway(authToken, ID, amount);
    const options = {
      key: 'rzp_live_8l4xyXelQxA8Xi', //Prod Credentials
      // key: 'rzp_test_OME1N5V70ECevu', //Beta Credentials
      amount: 1000,
      currency: 'INR',
      name: 'ScopeHai.com',
      description: 'Test Transaction',
      order_id: orderId,
      handler: async function (response) {
        console.log(response)
        const paymentData = {
          razorpay_order_id: response.razorpay_order_id,
          razorpay_payment_id: response.razorpay_payment_id,
          razorpay_signature: response.razorpay_signature,
          appliedTo: 'Placement Drive',
          userId: ID,
          amount: 1000,
          PlacementDriveId: PDriveData.ID
        }
        // Verify the payment on the backend
        const verifyRes = await paymentGatewayVerifyPlacementDrive(paymentData)

        if (verifyRes.data.success) {
          console.log('CHANGE BUTTON STATUS')
          setDisableButton(false)
          const data = {
            EmpID: PDriveData.EmployerID,
            JobID: null,
            JobTitle: null,
            placementID: PDriveData.ID,
            tokenUserID: ID,
            status: 'Applied'
          }

          const drive = async () => {
            const driveData = await createJobApplication(data, authToken)
            if (driveData?.data === 'Job appliation created successfully!') {
              // toast.success('Apllied successfully!', {
              //   position: 'top-right',
              //   autoClose: 5000,
              //   hideProgressBar: false,
              //   closeOnClick: true,
              //   pauseOnHover: true,
              //   draggable: true,
              //   progress: undefined,
              //   theme: 'light'
              // })
              setShowSuccessMessageModal({ action: true, type: 'payment' })
            }
          }
          drive()
          setRefreshData(prev => !prev)
        } else {
          alert('Payment verification failed. Try again.')
        }
      },
      theme: {
        color: '#378B7A'
      }
    }

    const rzp = new window.Razorpay(options)
    rzp.open()
    // handleClose();
    setDisableButton(false)
    //   hideVerificationModal();
  }
  const loadRazorpayScript = () => {
    return new Promise(resolve => {
      const script = document.createElement('script')
      script.src = 'https://checkout.razorpay.com/v1/checkout.js'
      script.onload = () => {
        resolve(true)
      }
      script.onerror = () => {
        resolve(false)
      }
      document.body.appendChild(script)
    })
  }

  return (
    <div id="appCapsule">
      <div class="container">
        {/* <pre>{JSON.stringify(PDriveData, null, 2)}</pre> */}

        <div class="row mt-3 d-flex justify-content-center">
          <div class="col-12 col-md-12">
            {role === 'Employer' && (
              <Link
                to="/emp-placement-drives"
                className="m-0 text-black fs-6 fw-bold d-flex"
              >
                <span class="d-flex align-items-center">
                  <ion-icon name="arrow-back-outline" class="me-1"></ion-icon>
                </span>
                Back to Placement Drive
              </Link>
            )}
            {role === 'Candidate' && (
              <Link
                to="/placement-drive"
                className="m-0 text-black fs-6 fw-bold d-flex"
              >
                <span class="d-flex align-items-center">
                  <ion-icon name="arrow-back-outline" class="me-1"></ion-icon>
                </span>
                Back to Placement Drive
              </Link>
            )}

            <div class="mt-3">
              <div
                style={{
                  backgroundImage: `url(${PDriveData?.Image || SampleBg})`,
                  backgroundPosition: 'center',
                  backgroundSize: 'cover',
                  height: '65vh',
                  borderRadius: '20px'
                }}
              ></div>
            </div>
          </div>
          <div class="col-12 col-md-12 pt-5">
            <div className="d-flex justify-content-between">
              <div>
                <h1 class="fw-bold" style={{ fontSize: '32px' }}>
                  {PDriveData?.Title}&nbsp;
                  {PDriveData?.status == 'Applied' && (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="36"
                      height="36"
                      viewBox="0 0 24 24"
                      fill="#2563eb"
                      stroke="#ffffff"
                      stroke-width="1"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="lucide lucide-badge-check-icon lucide-badge-check"
                    >
                      <path d="M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z" />
                      <path d="m9 12 2 2 4-4" />
                    </svg>
                  )}
                </h1>
                <p class="text-secondary">{PDriveData?.Criteria}</p>
              </div>
              {(role === 'Employer' || role === 'Admin' || role === 'Counsellor') && (
                <div>
                  {disableButton === false && (
                    <>
                      <button className="btn btn-primary d-none d-md-block" onClick={handelEdit}>
                        Edit
                      </button>
                      <button className="btn btn-primary d-block d-md-none"  style={{position: 'fixed', bottom: '50px', left: '50%', transform: 'translate(-50%, 0%)'}} onClick={handelEdit}>
                        Edit
                      </button>
                    </>
                  )}
                </div>
              )}
              {role === 'Candidate' && (
                <div>
                  {PDriveData?.status == 'Pending' && (
                    <>
                      <button className="btn btn-warning d-none d-md-block" disabled>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="1"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="lucide lucide-timer-icon lucide-timer"
                        >
                          <line x1="10" x2="14" y1="2" y2="2" />
                          <line x1="12" x2="15" y1="14" y2="11" />
                          <circle cx="12" cy="14" r="8" />
                        </svg>
                        <span className="ms-1">Pending</span>
                      </button>
                      <button className="btn btn-warning btn-lg d-block d-md-none" style={{position: 'fixed', bottom: '50px', left: '50%', transform: 'translate(-50%, 0%)', borderRadius: '100px'}} disabled>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="1"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="lucide lucide-timer-icon lucide-timer"
                        >
                          <line x1="10" x2="14" y1="2" y2="2" />
                          <line x1="12" x2="15" y1="14" y2="11" />
                          <circle cx="12" cy="14" r="8" />
                        </svg>
                        <span className="ms-1">Pending</span>
                      </button>
                    </>
                  )}
                  {PDriveData?.status == 'Accepted' && (
                    <>
                    <button
                      className="btn btn-success d-none d-md-block"
                      onClick={() => {
                        handleApply('Applied')
                      }}
                      disabled={disableButton}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="1"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="lucide lucide-credit-card-icon lucide-credit-card"
                      >
                        <rect width="20" height="14" x="2" y="5" rx="2" />
                        <line x1="2" x2="22" y1="10" y2="10" />
                      </svg>
                      <span className="ms-1">Pay to Proceed</span>
                    </button>
                    <button
                      className="btn btn-success btn-lg d-block d-md-none"
                      onClick={() => {
                        handleApply('Applied')
                      }}
                      disabled={disableButton}
                      style={{position: 'fixed', bottom: '50px', left: '50%', transform: 'translate(-50%, 0%)', borderRadius: '100px'}}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="1"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="lucide lucide-credit-card-icon lucide-credit-card"
                      >
                        <rect width="20" height="14" x="2" y="5" rx="2" />
                        <line x1="2" x2="22" y1="10" y2="10" />
                      </svg>
                      <span className="ms-1">Pay to Proceed</span>
                    </button>
                    </>
                  )}
                  {PDriveData?.status == 'Rejected' && (
                    <>
                      <button className="btn btn-danger d-none d-md-block" disabled>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="1"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="lucide lucide-ban-icon lucide-ban"
                        >
                          <circle cx="12" cy="12" r="10" />
                          <path d="m4.9 4.9 14.2 14.2" />
                        </svg>
                        <span className="ms-1">Rejected</span>
                      </button>
                      <button className="btn btn-danger btn-lg d-block d-md-none" style={{position: 'fixed', bottom: '50px', left: '50%', transform: 'translate(-50%, 0%)', borderRadius: '100px'}} disabled>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="1"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="lucide lucide-ban-icon lucide-ban"
                        >
                          <circle cx="12" cy="12" r="10" />
                          <path d="m4.9 4.9 14.2 14.2" />
                        </svg>
                        <span className="ms-1">Rejected</span>
                      </button>
                    </>
                  )}
                  {PDriveData?.status == 'noPayment' && (
                    <>
                    <button
                      className="btn btn-success d-none d-md-block"
                      onClick={() => {
                        handleApply('Pending')
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="1"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="lucide lucide-refresh-cw-icon lucide-refresh-cw"
                      >
                        <path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8" />
                        <path d="M21 3v5h-5" />
                        <path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16" />
                        <path d="M8 16H3v5" />
                      </svg>
                      <span className="ms-1">Request Again</span>
                    </button>
                    <button
                      className="btn btn-success btn-lg d-block d-md-none"
                      onClick={() => {
                        handleApply('Pending')
                      }}
                      style={{position: 'fixed', bottom: '50px', left: '50%', transform: 'translate(-50%, 0%)', borderRadius: '100px'}}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="1"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="lucide lucide-refresh-cw-icon lucide-refresh-cw"
                      >
                        <path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8" />
                        <path d="M21 3v5h-5" />
                        <path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16" />
                        <path d="M8 16H3v5" />
                      </svg>
                      <span className="ms-1">Request Again</span>
                    </button>
                    </>
                  )}
                  {(PDriveData?.status == 'NotApplied' ||
                    !PDriveData?.status) && (
                      <>
                        <button
                          className="btn btn-success d-none d-md-block"
                          onClick={() => {
                            handleApply('Pending')
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="1"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class="lucide lucide-circle-check-big-icon lucide-circle-check-big"
                          >
                            <path d="M21.801 10A10 10 0 1 1 17 3.335" />
                            <path d="m9 11 3 3L22 4" />
                          </svg>
                          <span className="ms-1">Apply</span>
                        </button>
                        <button
                          className="btn btn-success btn-lg d-block d-md-none"
                          onClick={() => {
                            handleApply('Pending')
                          }}
                          style={{position: 'fixed', bottom: '50px', left: '50%', transform: 'translate(-50%, 0%)', zIndex: 999, borderRadius: '100px'}}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="1"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class="lucide lucide-circle-check-big-icon lucide-circle-check-big"
                          >
                            <path d="M21.801 10A10 10 0 1 1 17 3.335" />
                            <path d="m9 11 3 3L22 4" />
                          </svg>
                          <span className="ms-1">Apply</span>
                        </button>
                      </>
                    )}
                  {/* {PDriveData?.status == 'Applied' && (
                    <div className="border-0 d-flex align-items-center justify-content-center">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="#2563eb" stroke="#ffffff" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-badge-check-icon lucide-badge-check"><path d="M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"/><path d="m9 12 2 2 4-4"/></svg>
                      <span>Applied</span>
                    </div>
                  )} */}
                  {/* {disableButton === 'applying' && (
                                        <button className='btn btn-warning' disabled>Pending</button>
                                    )}

                                    {PDriveData?.status === 'Applied' && (
                                        <button className='btn btn-warning' disabled>Applied</button>
                                    )}

                                    {disableButton !== true && disableButton !== 'applying' && PDriveData?.status !== 'Applied' && (
                                        <button className='btn btn-primary' onClick={handleApply}>Apply</button>
                                    )} */}
                </div>
              )}
            </div>
            {PDriveData?.Highlights && PDriveData?.Highlights.length > 0 ? (
              <ul class="text-secondary">
                {PDriveData?.Highlights.map((v, k) => (
                  <li key={k.id}>{v.title}</li>
                ))}
              </ul>
            ) : (
              <ul class="text-secondary">
                <li>N/A</li>
                <li>N/A</li>
                <li>N/A</li>
              </ul>
            )}
          </div>
          <hr class="mt-2 mb-2" />
          <div class="row mt-4">
            <div class="col-12 col-md-4 mb-2">
              <div
                class="card border-0"
                style={{
                  borderRadius: '10px',
                  boxShadow: '0px 0px 10px #0000001F'
                }}
              >
                <div class="card-body d-flex justify-content-between">
                  <div style={{ borderLeft: '4px solid #FF924F' }}>
                    <div class="ps-3">
                      {PDriveData?.Openings ? (
                        <>
                          <h2 class="fw-bold">{PDriveData?.Openings}</h2>
                          <h6 class="mb-0" style={{ fontSize: '14px' }}>
                            Openings
                          </h6>
                        </>
                      ) : (
                        <>
                          <h2 class="fw-bold">N/A</h2>
                          <h6 class="mb-0" style={{ fontSize: '14px' }}>
                            Openings
                          </h6>
                        </>
                      )}
                    </div>
                  </div>
                  <div class="d-flex justify-content-center align-items-center">
                    <div
                      class="d-flex justify-content-center align-items-center p-1"
                      style={{
                        backgroundColor: '#FF924F1A',
                        borderRadius: '5px'
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#FF924F"
                        stroke-width="1"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="lucide lucide-users"
                      >
                        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                        <circle cx="9" cy="7" r="4" />
                        <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-4 mb-2">
              <div
                class="card border-0"
                style={{
                  borderRadius: '10px',
                  boxShadow: '0px 0px 10px #0000001F'
                }}
              >
                <div class="card-body d-flex justify-content-between">
                  <div style={{ borderLeft: '3px solid #4B7BFF' }}>
                    <div class="ps-3">
                      {PDriveData?.TotalCompany ? (
                        <>
                          <h2 class="fw-bold">{PDriveData?.TotalCompany}</h2>
                          <h6 class="mb-0" style={{ fontSize: '14px' }}>
                            TotalCompany
                          </h6>
                        </>
                      ) : (
                        <>
                          <h2 class="fw-bold">N/A</h2>
                          <h6 class="mb-0" style={{ fontSize: '14px' }}>
                            TotalCompany
                          </h6>
                        </>
                      )}
                    </div>
                  </div>
                  <div class="d-flex justify-content-center align-items-center">
                    <div
                      class="d-flex justify-content-center align-items-center p-1"
                      style={{
                        backgroundColor: '#4B7BFF1A',
                        borderRadius: '5px'
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#4B7BFF"
                        stroke-width="1"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="lucide lucide-building-2"
                      >
                        <path d="M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z" />
                        <path d="M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2" />
                        <path d="M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2" />
                        <path d="M10 6h4" />
                        <path d="M10 10h4" />
                        <path d="M10 14h4" />
                        <path d="M10 18h4" />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-4 mb-2">
              <div
                class="card border-0"
                style={{
                  borderRadius: '10px',
                  boxShadow: '0px 0px 10px #0000001F'
                }}
              >
                <div class="card-body d-flex justify-content-between">
                  <div style={{ borderLeft: '3px solid #25BF5B' }}>
                    <div class="ps-3">
                      {PDriveData?.AvgPackage ? (
                        <>
                          <h2 class="fw-bold">{PDriveData?.AvgPackage}</h2>
                          <h6 class="mb-0" style={{ fontSize: '14px' }}>
                            Average Package
                          </h6>
                        </>
                      ) : (
                        <>
                          <h2 class="fw-bold">N/A</h2>
                          <h6 class="mb-0" style={{ fontSize: '14px' }}>
                            Average Package
                          </h6>
                        </>
                      )}
                    </div>
                  </div>
                  <div class="d-flex justify-content-center align-items-center">
                    <div
                      class="d-flex justify-content-center align-items-center p-1"
                      style={{
                        backgroundColor: '#25BF5B1A',
                        borderRadius: '5px'
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#25BF5B"
                        stroke-width="1"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="lucide lucide-receipt-indian-rupee"
                      >
                        <path d="M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z" />
                        <path d="M8 7h8" />
                        <path d="M12 17.5 8 15h1a4 4 0 0 0 0-8" />
                        <path d="M8 11h8" />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-12">
              <ul
                class="p-0 d-flex gap-2 mt-1"
                style={{ listStyleType: 'none', overflow: 'hidden' }}
              >
                {PDriveData?.Skills && PDriveData?.Skills.length > 0 ? (
                  <>
                    <li
                      class="fs-6 text-nowrap text-black fw-bold"
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginBottom: '16px'
                      }}
                    >
                      Eligibility:
                    </li>
                    <div className="d-flex" style={{ overflow: 'scroll' }}>
                      {PDriveData?.Skills.map((v, k) => (
                        <li>
                          <span
                            class="px-3 py-3 d-flex align-items-center text-nowrap text-black"
                            style={{
                              backgroundColor: '#EBF4F1',
                              fontSize: '15px',
                              borderRadius: '8px',
                              height: '25px'
                            }}
                          >
                            {v}
                          </span>
                        </li>
                      ))}
                    </div>
                  </>
                ) : (
                  <>
                    <li
                      class="fs-6 text-nowrap text-black fw-bold"
                      style={{ display: 'flex', alignItems: 'center' }}
                    >
                      Eligibility:
                    </li>
                    <li>
                      <span
                        class="px-3 py-3 d-flex align-items-center text-nowrap text-black"
                        style={{
                          backgroundColor: '#EBF4F1',
                          fontSize: '15px',
                          borderRadius: '8px',
                          height: '25px'
                        }}
                      >
                        N/A
                      </span>
                    </li>
                    <li>
                      <span
                        class="px-3 py-3 d-flex align-items-center text-nowrap text-black"
                        style={{
                          backgroundColor: '#EBF4F1',
                          fontSize: '15px',
                          borderRadius: '8px',
                          height: '25px'
                        }}
                      >
                        N/A
                      </span>
                    </li>
                    <li>
                      <span
                        class="px-3 py-3 d-flex align-items-center text-nowrap text-black"
                        style={{
                          backgroundColor: '#EBF4F1',
                          fontSize: '15px',
                          borderRadius: '8px',
                          height: '25px'
                        }}
                      >
                        N/A
                      </span>
                    </li>
                  </>
                )}
              </ul>
            </div>
          </div>
          {/* this is the What include in this test section start D-NONE*/}
          <hr class="d-none mt-2 mb-2" />
          <div class="d-none col-12 col-md-12 mt-2">
            <h1 class="fw-bold" style={{ fontSize: '32px' }}>
              What include in this test ?
            </h1>
            <div class="row">
              <div class="col-12 col-md-6">
                <ul class="p-0" style={{ listStyleType: 'none' }}>
                  <li class="mt-3">
                    <div class="d-flex align-items-center">
                      <div
                        class="d-flex justify-content-center align-items-center me-2"
                        style={{
                          height: '35px',
                          width: '35px',
                          backgroundColor: '#EBF4F1',
                          borderRadius: '10px'
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#25BF5B"
                          stroke-width="1"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="lucide lucide-users"
                        >
                          <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                          <circle cx="9" cy="7" r="4" />
                          <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                          <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                        </svg>
                      </div>
                      <p class="mb-0 text-black" style={{ fontSize: '16px' }}>
                        Lorem ipsum dolor sit amet consectetur. Consequat aenean
                        est.{' '}
                      </p>
                    </div>
                  </li>
                  <li class="mt-3">
                    <div class="d-flex align-items-center">
                      <div
                        class="d-flex justify-content-center align-items-center me-2"
                        style={{
                          height: '35px',
                          width: '35px',
                          backgroundColor: '#EBF4F1',
                          borderRadius: '10px'
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#25BF5B"
                          stroke-width="1"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="lucide lucide-users"
                        >
                          <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                          <circle cx="9" cy="7" r="4" />
                          <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                          <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                        </svg>
                      </div>
                      <p class="mb-0 text-black" style={{ fontSize: '16px' }}>
                        Lorem ipsum dolor sit amet consectetur tortor posuere
                        nunc.
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
              <div class="col-12 col-md-6">
                <ul class="p-0" style={{ listStyleType: 'none' }}>
                  <li class="mt-3">
                    <div class="d-flex align-items-center">
                      <div
                        class="d-flex justify-content-center align-items-center me-2"
                        style={{
                          height: '35px',
                          width: '35px',
                          backgroundColor: '#EBF4F1',
                          borderRadius: '10px'
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#25BF5B"
                          stroke-width="1"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="lucide lucide-users"
                        >
                          <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                          <circle cx="9" cy="7" r="4" />
                          <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                          <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                        </svg>
                      </div>
                      <p class="mb-0 text-black" style={{ fontSize: '16px' }}>
                        Lorem ipsum dolor sit amet consectetur.
                      </p>
                    </div>
                  </li>
                  <li class="mt-3">
                    <div class="d-flex align-items-center">
                      <div
                        class="d-flex justify-content-center align-items-center me-2"
                        style={{
                          height: '35px',
                          width: '35px',
                          backgroundColor: '#EBF4F1',
                          borderRadius: '10px'
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#25BF5B"
                          stroke-width="1"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="lucide lucide-users"
                        >
                          <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                          <circle cx="9" cy="7" r="4" />
                          <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                          <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                        </svg>
                      </div>
                      <p class="mb-0 text-black" style={{ fontSize: '16px' }}>
                        Lorem ipsum dolor sit amet consectetur. Augue sem augue
                        con.
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          {/* this is the What include in this test section start */}

          <hr class="mt-2 mb-2" />
          <div class="col-12 col-md-12 mt-2">
            <h1 class="fw-bold" style={{ fontSize: '32px' }}>
              Requirements
            </h1>
            <ul class="text-secondary">
              {PDriveData?.Process && PDriveData?.Process.length > 0 ? (
                <>
                  {PDriveData?.Process.map((v, k) => (
                    <li key={k}>{v.title}</li>
                  ))}
                </>
              ) : (
                <>
                  <li>N/A</li>
                  <li>N/A</li>
                  <li>N/A</li>
                </>
              )}
            </ul>
          </div>

          {/* Reviews section start */}
          <hr class="d-none mt-2 mb-2" />
          <div class="d-none col-12 col-md-12 mt-2 pb-5">
            <h1 class="fw-bold" style={{ fontSize: '32px' }}>
              Reviews
            </h1>
            <Splide
              options={{
                rewind: true,
                type: 'loop',
                perPage: 3,
                perMove: 1,
                arrows: false,
                breakpoints: {
                  768: {
                    perPage: 1 // Show only 1 slide per page on mobile screens
                  }
                }
              }}
              aria-label="React Splide Example"
            >
              {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((v, k) => {
                return (
                  <SplideSlide>
                    <div
                      class="card border-0"
                      style={{
                        boxShadow: '0px 0px 10px #0000001F',
                        borderRadius: '5px'
                      }}
                    >
                      <div class="card-body">
                        <img src={Quotes} style={{ width: '10%' }} />
                        <p
                          class="text-secondary pt-2"
                          style={{ fontSize: '12px', lineHeight: 'inherit' }}
                        >
                          Lörem ipsum nisin ultralöskade fösa sor hypofähödat.
                          Heterotism ålasosade gibeck: hånin lysa. Dende fäsk.
                          Doment krogisk, sabåligen. Deciktig pantik.
                        </p>
                        <div class="d-flex justify-content-between">
                          <div class="d-flex flex-column">
                            <h6
                              class="mb-0 fw-bold"
                              style={{ fontSize: '12px' }}
                            >
                              Jenny Wilson
                            </h6>
                            <p
                              style={{ fontSize: '10px' }}
                              class="mb-0 text-secondary"
                            >
                              PHP Developer
                            </p>
                          </div>
                          <div
                            style={{
                              height: '35px',
                              width: '35px',
                              backgroundImage: `url(${ReviewUser})`,
                              backgroundPosition: 'center',
                              backgroundSize: 'cover',
                              borderRadius: '100%'
                            }}
                          ></div>
                        </div>
                      </div>
                    </div>
                  </SplideSlide>
                )
              })}
            </Splide>
          </div>
          {/* Reviews section end */}

          <hr class="mt-2 mb-2" />
          <div class="col-12 col-md-12 mt-2">
            <h1 class="fw-bold" style={{ fontSize: '32px' }}>
              Frequently Asked Questions
            </h1>
            <div>
              <Accordion defaultActiveKey="0">
                {PDriveData?.Faqs && PDriveData?.Faqs.length > 0 ? (
                  <>
                    {PDriveData?.Faqs?.map((v, k) => (
                      <Accordion.Item eventKey={k.toString()} key={k}>
                        <Accordion.Header>{v.question}</Accordion.Header>
                        <Accordion.Body>
                          <p style={{ fontSize: '14px' }}>{v.answer}</p>
                        </Accordion.Body>
                      </Accordion.Item>
                    ))}
                  </>
                ) : (
                  <>
                    <Accordion.Item eventKey="0">
                      <Accordion.Header>N/A</Accordion.Header>
                      <Accordion.Body>
                        <p style={{ fontSize: '14px' }}>N/A</p>
                      </Accordion.Body>
                    </Accordion.Item>
                  </>
                )}
              </Accordion>

              {/* <Accordion defaultActiveKey="0">
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header>Lorem ipsum dolor sit amet, consectetur ?</Accordion.Header>
                                    <Accordion.Body>
                                        <p style={{ fontSize: '14px' }}>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Tortor pretium diam vel nulla tellus lorem sollicitudin fermentum ultricies. Aenean a consectetur mi libero. Accumsan, ultrices nunc orci ac amet volutpat. Morbi semper erat ullamcorper adipiscing nisi pellentesque.</p>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="1">
                                    <Accordion.Header>Lorem ipsum dolor sit amet consectetur. Eu tortor molestie sed consequat tempus com.</Accordion.Header>
                                    <Accordion.Body>
                                        <p style={{ fontSize: '14px' }}>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                                            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
                                            minim veniam, quis nostrud exercitation ullamco laboris nisi ut
                                            aliquip ex ea commodo consequat. Duis aute irure dolor in
                                            reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
                                            pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
                                            culpa qui officia deserunt mollit anim id est laborum.</p>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="3">
                                    <Accordion.Header>Lorem ipsum dolor sit amet consectetur. Aliquam ac consectetur vitae laoreet ut.</Accordion.Header>
                                    <Accordion.Body>
                                        <p style={{ fontSize: '14px' }}>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                                            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
                                            minim veniam, quis nostrud exercitation ullamco laboris nisi ut
                                            aliquip ex ea commodo consequat. Duis aute irure dolor in
                                            reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
                                            pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
                                            culpa qui officia deserunt mollit anim id est laborum.</p>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="4">
                                    <Accordion.Header>Lorem ipsum dolor sit amet consectetur. Quam aliquet pellentesque donec cursus neque.</Accordion.Header>
                                    <Accordion.Body>
                                        <p style={{ fontSize: '14px' }}>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                                            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
                                            minim veniam, quis nostrud exercitation ullamco laboris nisi ut
                                            aliquip ex ea commodo consequat. Duis aute irure dolor in
                                            reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
                                            pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
                                            culpa qui officia deserunt mollit anim id est laborum.</p>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="5">
                                    <Accordion.Header>Lorem ipsum dolor sit amet consectetur. Ultrices curabitur nunc elementum libero cursus pretium felis.</Accordion.Header>
                                    <Accordion.Body>
                                        <p style={{ fontSize: '14px' }}>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                                            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
                                            minim veniam, quis nostrud exercitation ullamco laboris nisi ut
                                            aliquip ex ea commodo consequat. Duis aute irure dolor in
                                            reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
                                            pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
                                            culpa qui officia deserunt mollit anim id est laborum.</p>
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Accordion> */}
            </div>
          </div>
          
          {PDriveData?.CompanyData?.length > 0 &&
            <>
              <hr class="mt-2 mb-2" />
              <div class="col-12 col-md-12 mt-2">
                <h1 class="fw-bold" style={{ fontSize: '32px' }}>
                  Participants Company
                </h1>
                <div class="d-flex gap-4">
                  {PDriveData?.CompanyData?.map((v,k) => {
                    return (
                      <div class="border" style={{borderRadius: "5px"}}>
                        <img src={v.image} width={80} height={80} style={{borderRadius: '5px', objectFit: 'cover'}} />
                      </div>
                    )
                  })}
                </div>
              </div>
            </>
          }
        </div>
      </div>
      <Modal
        show={showSuccessMessageModal.action}
        onHide={() => {
          setShowSuccessMessageModal({ action: false, type: '' })
        }}
        centered
        style={{ borderRadius: '15px' }}
      >
        <Modal.Body style={{ background: '#cdffd8', borderRadius: '15px' }}>
          <div className="position-relative">
            {/* <div className="position-absolute" onClick={() => {setShowSuccessMessageModal(false)}} style={{ top: 0, right: 0 }}>
              <ion-icon name="close-outline" className="fs-2"></ion-icon>
            </div> */}
            <h2 className="text-center">{(showSuccessMessageModal.type) ? 'Applied Successfully' : 'Payment Successfull'}</h2>
            {showSuccessMessageModal.type == 'apply' &&
              <p className="text-center mt-2 fs-5">
                HR will get in touch with you soon. <br /> Thank You
              </p>
            }
            {showSuccessMessageModal.type == 'payment' &&
              <p className="text-center mt-2 fs-5">
                Payment reciept will be shared throught WhatsApp. <br /> Thank You
              </p>
            }
          </div>
        </Modal.Body>
      </Modal>
    </div>
  )
}

const mapStateToProps = ({ auth }) => {
  const { ID, authToken, role } = auth
  return {
    ID,
    authToken,
    role
  }
}

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(DriveDetail)
